import axios from "axios";
import {
  getStoredUser,
  getStoredDeviceInfo,
  getReduxCompany,
} from "../helper/sessionHelper";
import { getStoredCompany } from "../helper/sessionHelper";
import secureLocalStorage from "react-secure-storage";

const devideInfo = getStoredDeviceInfo();
const user = getStoredUser();
const company = getStoredCompany(); //secureLocalStorage.getItem("company");

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_ASSETZ_BASE_URL,
  //timeout: 60000,
  headers: {
    //   //Authorization: `Bearer ${sessionStorage.getItem("session_accesstoken")}`,
    // "Content-Type": "application/json",
    // Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    InternalApiKey: "123",
    "X-User-UserId": getReduxCompany()?.userId || 0,
    "X-User-UserName": getReduxCompany()?.userName || "",
    //"X-User-CompanyId": getReduxCompany()?.companyId || 0,
    "X-User-CompanyId": getStoredCompany()?.companyId || 0,
    "X-IP-Address": devideInfo?.iPAddress || "",
    "X-Device-Info": devideInfo?.deviceInfo || "",
    "X-Is-Browser": devideInfo?.isMobile,
  },
  //timeout: 5000,
});

export default axiosApi;
